import { useState } from 'react';
import { Save, RotateCcw } from 'lucide-react';
import { useSettings } from '../shared/contexts/SettingsContext';
import { PageTitle} from '../../../../_metronic/layout/core'

export const SettingsPage = () => {
  //const { settings, updateSettings } = useSettings();
  const settings = {diasCoberturaAlvo:21, leadTime:7}
  const [leadTime, setLeadTime] = useState(settings.leadTime);
  const [diasCoberturaAlvo, setDiasCoberturaAlvo] = useState(settings.diasCoberturaAlvo);
  const [saved, setSaved] = useState(false);

  const handleSave = () => {
    //updateSettings({ leadTime, diasCoberturaAlvo });
    setSaved(true);
    setTimeout(() => setSaved(false), 3000);
  };

  const handleReset = () => {
    setLeadTime(7);
    setDiasCoberturaAlvo(21);
    //updateSettings({ leadTime: 7, diasCoberturaAlvo: 21 });
  };

  const hasChanges =
    leadTime !== settings.leadTime || diasCoberturaAlvo !== settings.diasCoberturaAlvo;

  return (
    <div>
        <PageTitle>Configurações</PageTitle>
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Configurações</h1>
        <p className="text-gray-600">
          Configure os parâmetros globais do sistema de reposição
        </p>
      </div>

      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-8 max-w-2xl">
        <h2 className="text-xl font-semibold text-gray-900 mb-6">Parâmetros de Cálculo</h2>

        <div className="space-y-6">
          <div>
            <label htmlFor="leadTime" className="block text-sm font-medium text-gray-700 mb-2">
              Lead Time (dias)
            </label>
            <p className="text-sm text-gray-500 mb-3">
              Tempo entre o pedido e a entrega do fornecedor. Usado para calcular o estoque de segurança e o ponto de pedido.
            </p>
            <input
              type="number"
              id="leadTime"
              min="1"
              value={leadTime}
              onChange={(e) => setLeadTime(Number(e.target.value))}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
            />
          </div>

          <div>
            <label htmlFor="cobertura" className="block text-sm font-medium text-gray-700 mb-2">
              Dias de Cobertura Alvo
            </label>
            <p className="text-sm text-gray-500 mb-3">
              Meta de dias que o estoque deve cobrir após a reposição. Usado para calcular o estoque alvo ideal.
            </p>
            <input
              type="number"
              id="cobertura"
              min="1"
              value={diasCoberturaAlvo}
              onChange={(e) => setDiasCoberturaAlvo(Number(e.target.value))}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition"
            />
          </div>
        </div>

        <div className="mt-8 flex gap-3">
          <button
            onClick={handleSave}
            //disabled={!hasChanges}
            disabled={true}
            className={`flex items-center gap-2 px-6 py-2.5 rounded-lg font-medium transition ${
              hasChanges
                ? 'bg-gray-200 text-gray-400 cursor-not-allowed'//'bg-blue-600 text-white hover:bg-blue-700'
                : 'bg-gray-200 text-gray-400 cursor-not-allowed'
            }`}
          >
            <Save className="w-5 h-5" />
            Salvar Alterações
          </button>

        </div>

        {saved && (
          <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
            <p className="text-sm text-green-900 font-medium">
              Configurações salvas com sucesso! Os cálculos serão atualizados automaticamente.
            </p>
          </div>
        )}
      </div>

      <div className="mt-6 bg-blue-50 border border-blue-200 rounded-lg p-4 max-w-2xl">
        <h3 className="text-sm font-semibold text-blue-900 mb-2">Como isso afeta os cálculos?</h3>
        <ul className="text-sm text-blue-900 space-y-1 list-disc list-inside">
          <li>O Lead Time afeta diretamente o Estoque Mínimo (SS) e o Ponto de Pedido (ROP)</li>
          <li>A Cobertura Alvo define quanto estoque você deseja manter após a reposição</li>
          <li>Valores mais altos aumentam a segurança mas elevam o custo de estoque</li>
          <li>Todas as mudanças são aplicadas instantaneamente na tabela e no dashboard</li>
        </ul>
      </div>
    </div>
  );
};
